import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class OptionChainToolUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getOptionChainToolData(data);
    }
}
export default OptionChainToolUseCase;
